export const instantAccessItems: string[] = [
  'Tutti gli 8 volumi completi, pronti da stampare',
  'Tecnica, storia dell’arte e verifiche allineate in ogni unità',
  'Percorso pronto dalla classe 1ª primaria alla 3ª media',
  'Schede pronte all’uso, senza bisogno di formazione artistica',
  'Contenuti organizzati secondo la progressione naturale della materia Arte e Immagine',
  'Nessun abbonamento: accesso immediato e permanente',
]
